module.exports = __webpack_public_path__ + "img/North_Lanarkshire.5bb729c4.png";